<p-autoComplete [(ngModel)]="selectedSupplier" (onSelect)="selectSupplier($event)"
  [suggestions]="filteredSuppliers" (completeMethod)="filterSupplier($event)" placeholder="Supplier..."
  [dropdown]="true" dropdownMode="blank" field="name" [minLength]="1">
</p-autoComplete>
